import React from 'react'
// libs
import { reduxForm } from 'redux-form'
// constants
import { Forms, Modals, OBJECT_ENTITY_NAMES } from 'constants/index'
// types
import { IPlan } from 'types/graphql'
import { InjectedFormProps } from 'redux-form/lib/reduxForm'
// components
import { FloatingActions } from 'components/FormElements'
// hooks
import { useFieldAccess, useFormDirtyCount, useShowModal, useReviewFieldIds } from 'hooks'
// views
import { Collapse, Form } from 'components/Modals/PlanItems/styles'
// utils
import { generateFields } from 'utils/fields'

interface Props {
  plan: IPlan
}

const SidebarInfoForm: React.FC<InjectedFormProps<any, Props> & Props> = ({
  plan,
  form,
  reset,
  submitting,
  handleSubmit,
  initialValues
}) => {
  const [isCollapsed, setCollapsed] = React.useState(false)

  const { planModifyPlan, planSetUserPlanSecurity } = plan.currentPermissions

  const canViewRestricted = useFieldAccess(plan)
  const reviewFieldIds = useReviewFieldIds(OBJECT_ENTITY_NAMES.PLAN)

  const { dirtyFieldsCount } = useFormDirtyCount(form)

  const { showModal } = useShowModal({
    modalType: Modals.CONFIRM_CHANGE_PLAN_TYPE_MODAL
  })

  const handleCollapse = () => setCollapsed(!isCollapsed)

  const onPlanTypeChange = (planType) => {
    if (planType.value === initialValues.planType.value) {
      return
    }

    showModal({ planTypeId: planType.value })
  }

  return (
    <>
      <Collapse handleClick={handleCollapse} isCollapsed={isCollapsed}>
        About this plan
      </Collapse>
      {!isCollapsed && (
        <Form onSubmit={handleSubmit}>
          {plan.planType.fields
            .filter((field) => !reviewFieldIds.includes(field.id))
            .map((field) =>
              generateFields({
              field,
              form,
              canViewRestricted,
              callback: onPlanTypeChange as any,
              canModify: planModifyPlan && !plan.locked,
              canSetPermissions: planSetUserPlanSecurity
            })
          )}
          <FloatingActions submitting={submitting} onCancel={reset} dirtyCount={dirtyFieldsCount} />
        </Form>
      )}
    </>
  )
}

export default reduxForm<any, Props>({
  destroyOnUnmount: false,
  enableReinitialize: true,
  form: Forms.PLAN_EDIT_FORM
})(SidebarInfoForm)
